var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgSpotify = function SvgSpotify(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2Zm4.587 14.435a.624.624 0 0 1-.87.152c-2.343-1.647-6.242-1.738-8.875-1.124a.626.626 0 0 1-.282-1.22c2.894-.67 7.219-.547 9.875 1.322a.625.625 0 0 1 .152.87Zm1.22-2.439a.625.625 0 0 1-.872.143c-2.719-1.951-6.059-2.436-10.516-1.526a.626.626 0 0 1-.251-1.226c4.82-.983 8.473-.433 11.496 1.736a.627.627 0 0 1 .143.873Zm1.233-3.275a.625.625 0 0 1-.869.166c-3.446-2.338-8.685-2.35-12.076-1.15a.626.626 0 0 1-.416-1.18c3.688-1.303 9.405-1.276 13.196 1.295a.627.627 0 0 1 .165.87Z",
    fill: "currentColor"
  })));
};
export default SvgSpotify;